import { render, staticRenderFns } from "./GoalStatusReport.vue?vue&type=template&id=5535561e&scoped=true&"
import script from "./GoalStatusReport.vue?vue&type=script&lang=js&"
export * from "./GoalStatusReport.vue?vue&type=script&lang=js&"
import style0 from "./GoalStatusReport.vue?vue&type=style&index=0&id=5535561e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5535561e",
  null
  
)

export default component.exports